import { defineStore } from 'pinia'
import { fetchBonusConfig, getBonusMap } from '@ms/components/marketing/useBonus.js'

export const useBonusStore = defineStore('bonus', {
  state: () => ({
    // 最小嘉奖 selection 数量
    minBonusNum: 0,
    // 加奖配置
    bonusRatios: {},
    // 算bonus时候赔率大于多少
    qualifyingOddsLimit: 1.2
  }),
  getters: {
    bonusKey() {
      return Object.keys(this.bonusRatios).sort((a, b) => a - b)
    },
    maxBonusNum() {
      const { bonusKey } = this
      return parseInt(bonusKey[bonusKey.length - 1])
    },
    maxBonus() {
      const { bonusKey } = this
      const maxKey = bonusKey[bonusKey.length - 1]
      return this.bonusRatios[maxKey]
    }
  },
  actions: {
    async getBonusConfig() {
      const { bonusRatios, qualifyingOddsLimit } = await fetchBonusConfig()

      const bonusList = bonusRatios
      if (bonusList.length) {
        this.minBonusNum = bonusList[0].qualifyingSelections
        this.bonusRatios = Object.freeze(getBonusMap(bonusList))
        this.qualifyingOddsLimit = qualifyingOddsLimit
      }
    },
    getBonusInfo(num) {
      if (num < 1) return
      const { minBonusNum, maxBonusNum } = this
      const nextKey = this.bonusKey.find((x) => x > num)
      const bonus = this.bonusRatios[nextKey]
      if (bonus === 0) {
        return
      }
      const validCount = num
      const min = minBonusNum - 1
      return {
        moreGameNum: nextKey - num,
        bonus,
        validCount,
        percent: (validCount - min) / (maxBonusNum - min)
      }
    },
    getBonusTip(num) {
      if (num < 1) return
      const bonusInfo = this.getBonusInfo(num)
      const { qualifyingOddsLimit, maxBonus } = this
      if (!bonusInfo || !maxBonus) return
      if (bonusInfo.validCount < this.maxBonusNum) {
        return {
          message: `Select ${bonusInfo.moreGameNum} more games (Each odds ≥ ${qualifyingOddsLimit}), get ${bonusInfo.bonus}% extra bonus!`,
          percent: bonusInfo.percent
        }
      } else {
        return {
          message: `Maximum bonus reached at ${maxBonus}%!`,
          percent: bonusInfo.percent
        }
      }
    }
  }
})
